import _ from 'lodash';
import {initReducerContext} from '@someok/simple-reducer-store';

import authActions from './actions';

export const GLOBAL_ADMIN_READ = 'global:admin:r';
export const GLOBAL_ADMIN_WRITE = 'global:admin:w';

/**
 * 判断用户是否存在给定权限。
 *
 * @param auths 允许的权限
 * @param useGlobalRW 允许读取超级权限中的读或写权限，如果不提供，则不读取超级权限
 * @return {boolean}
 */
function hasAuthorities(auths, useGlobalRW) {
    // console.log('auths, readOrWrite', auths, useGlobalRW);
    if (_.isEmpty(auths)) {
        throw new Error('[auths] 参数不能为空');
    }

    const userAuths = this.authorities ?? [];

    for (const auth of auths) {
        if (userAuths.includes(auth)) {
            return true;
        }
    }

    if (useGlobalRW === 'r') {
        return userAuths.includes(GLOBAL_ADMIN_READ);
    }
    if (useGlobalRW === 'w') {
        return userAuths.includes(GLOBAL_ADMIN_WRITE);
    }

    return false;
}

/**
 * 检测当前人员是否有系统管理权限
 */
function hasGlobalAuths() {
    const userAuths = this.authorities ?? [];

    if (_.isEmpty(userAuths)) {
        return false;
    }

    return !!userAuths.find(auth => auth.startsWith('global:'));
}

const initialState = {
    isLogin: false,
    user: undefined,
    authorities: undefined,
    tokens: undefined,
    isDefaultAppLayout: false,

    hasAuthorities,
    hasGlobalAuths,
};

const [useAuthStore, AuthStoreProvider, AuthContext] = initReducerContext(
    initialState,
    authActions
);

export {useAuthStore, AuthStoreProvider, AuthContext};
